document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('[data-category-icons]');

  wrappers.forEach(function (wrapper) {
    var scrollEl = wrapper.querySelector('[data-category-icons-scroll]');
    var prevBtn = wrapper.querySelector('[data-category-icons-prev]');
    var nextBtn = wrapper.querySelector('[data-category-icons-next]');

    if (!scrollEl || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;

      if (maxScroll <= 4) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }

      prevBtn.hidden = scrollEl.scrollLeft <= 4;
      nextBtn.hidden = scrollEl.scrollLeft >= maxScroll - 4;
    }

    function scrollByAmount(direction) {
      var amount = scrollEl.clientWidth * 0.7 * direction;
      scrollEl.scrollBy({ left: amount, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollByAmount(-1);
    });

    nextBtn.addEventListener('click', function () {
      scrollByAmount(1);
    });

    scrollEl.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});